import { Text } from "@chakra-ui/react";
import React from "react";

export const SectionTitle = ({ title }) => {
  return (
    <Text fontSize={"lg"} color="blackAlpha.900">
      {title}
    </Text>
  );
};
